import { CustomError } from "./CustomError";
import { logError, logWarning, logInfo } from "../../monitoring";

const shouldLog = error => {
  if (!error) {
    return true;
  }

  return !error.logged;
};

const levels = {
  error: Symbol("error"),
  info: Symbol("info"),
  warn: Symbol("warn")
};
const logMethods = {
  [levels.error]: logError,
  [levels.warn]: logWarning,
  [levels.info]: logInfo
};

export class LoggedError extends CustomError {
  constructor(error, logLevel = levels.error, attributes) {
    super(error);
    this.name = "LoggedError";
    if (shouldLog(error)) {
      const logMethod = logMethods[logLevel];
      logMethod(error, attributes);
      this.logged = true;
    }
  }
  static get error() {
    return levels.error;
  }
  static get info() {
    return levels.info;
  }
  static get warn() {
    return levels.warn;
  }
}
